const encoder = new TextEncoder();
function assertJsonValue(value, path) {
    if (value === undefined)
        throw new TypeError(`Undefined is not canonical JSON at ${path}`);
    if (typeof value === "number" && !Number.isFinite(value)) {
        throw new TypeError(`Non-finite number is not canonical JSON at ${path}`);
    }
    if (typeof value === "bigint" || typeof value === "function" || typeof value === "symbol") {
        throw new TypeError(`Unsupported canonical JSON value at ${path}`);
    }
}
function normalize(value, path) {
    assertJsonValue(value, path);
    if (value === null || typeof value !== "object")
        return value;
    if (Array.isArray(value)) {
        return value.map((item, index) => normalize(item, `${path}[${index}]`));
    }
    const result = {};
    for (const key of Object.keys(value).sort()) {
        const item = value[key];
        assertJsonValue(item, `${path}.${key}`);
        result[key] = normalize(item, `${path}.${key}`);
    }
    return result;
}
/**
 * Deterministic JSON used by every SharpPKI signer. Protocol objects intentionally
 * avoid floating-point values, so sorted UTF-8 JSON is sufficient for V1. The
 * conformance suite must be run by every non-TypeScript SDK.
 */
export function canonicalJson(value) {
    return JSON.stringify(normalize(value, "$"));
}
export function canonicalBytes(value) {
    return encoder.encode(canonicalJson(value));
}
function base64Url(bytes) {
    let binary = "";
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}
export async function sha256(value) {
    const bytes = canonicalBytes(value);
    const digest = await crypto.subtle.digest("SHA-256", bytes.slice().buffer);
    return base64Url(new Uint8Array(digest));
}
export async function sha256Bytes(bytes) {
    const digest = await crypto.subtle.digest("SHA-256", bytes.slice().buffer);
    return base64Url(new Uint8Array(digest));
}
export function constantTimeStringEqual(left, right) {
    const a = encoder.encode(left);
    const b = encoder.encode(right);
    let diff = a.length ^ b.length;
    const length = Math.max(a.length, b.length);
    for (let index = 0; index < length; index += 1) {
        diff |= (a[index % Math.max(1, a.length)] ?? 0) ^ (b[index % Math.max(1, b.length)] ?? 0);
    }
    return diff === 0;
}
//# sourceMappingURL=canonical.js.map